import { render, staticRenderFns } from "./AudienceCard.vue?vue&type=template&id=930f234a"
import script from "./AudienceCard.vue?vue&type=script&lang=js"
export * from "./AudienceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports